import { render } from "./Items.vue?vue&type=template&id=d1b8c232&ts=true"
import script from "./Items.vue?vue&type=script&lang=ts"
export * from "./Items.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__